import { getLabel, getApiPath, getLoginApiPath } from '@/helpers/Utils';

import moment from 'moment';

// Icon imports for attendance duration
import defaultTimetableIcon from '@/assets/img/icon/default.svg';
import eveningTimetableIcon from '@/assets/img/icon/evening.svg';
import morningTimetableIcon from '@/assets/img/icon/morning.svg';
import afternoonTimetableIcon from '@/assets/img/icon/afternoon.svg';
import midnightTimetableIcon from '@/assets/img/icon/midnight.svg';

export const UserRole = {
  Admin: 'Admin',
  Employee: 'Employee',
};
/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';
export const getLanguage = () => {
  if (localStorage.getItem('language')) return localStorage.getItem('language');
  return 'en';
};

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { key: 0, id: 'en', name: 'English', direction: 'ltr' },
  { key: 1, id: 'ar', name: 'Arabic', direction: 'rtl' },
  // { id: 'es', name: 'Español', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const scheduleTypeList = [
  { value: 1, id: 1, name: 'Weekly', label: 'Weekly' },
  { value: 2, id: 2, name: 'Monthly', label: 'Monthly' },
];

export const dailyScheduleTypeList = [
  {
    name: 'Immediate',
    label: getLabel('مباشر', 'Immediate'),
    value: 1,
    id: 1,
  },
  {
    name: 'Before Schedule Start',
    label: getLabel('قبل بداية الوردية', 'Before Schedule Start'),
    value: 2,
    id: 2,
  },
  {
    name: 'After Schedule Start ',
    label: getLabel('بعد بداية الوردية', 'After Schedule Start '),
    value: 3,
    id: 3,
  },
  {
    name: 'Before Schedule End',
    label: getLabel('قبل  نهاية الوردية', 'Before Schedule End'),
    value: 4,
    id: 4,
  },
  {
    name: 'After Schedule End',
    label: getLabel('بعد نهاية الوردية', 'After Schedule End'),
    value: 5,
    id: 5,
  },
];

export const daysOfWeekList = [
  { value: 1, id: 1, name: 'Sun', label: 'Sun' },
  { value: 2, id: 2, name: 'Mon', label: 'Mon' },
  { value: 3, id: 3, name: 'Tue', label: 'Tue' },
  { value: 4, id: 4, name: 'Wed', label: 'Wed' },
  { value: 5, id: 5, name: 'Thu', label: 'Thu' },
  { value: 6, id: 6, name: 'Fri', label: 'Fri' },
  { value: 7, id: 7, name: 'Sat', label: 'Sat' },
];
export const requestTypeList = [
  // { value: 0, key: 0, name: 'Please Select', label: 'Please Select' },
  { value: 2, key: 2, name: 'Leave', label: getLabel('اجازات', 'Leave') },
  {
    value: 3,
    key: 3,
    name: 'Remote Work',
    label: getLabel('عمل عن بعد', 'Remote Work'),
  },
  {
    value: 1,
    key: 1,
    name: 'Permission',
    label: getLabel('اذونات', 'Permission'),
  },
  {
    value: 4,
    key: 4,
    name: 'Manual Entry',
    label: getLabel('إدخال يدوي', 'Manual Entry'),
  },
];
export const elementTypeList = [
  {
    value: 0,
    key: 0,
    name: 'Please Select',
    label: getLabel('يرجى الاختيار', 'Please Select'),
  },
  {
    value: 1,
    key: 1,
    name: 'Text Box',
    label: getLabel('مربع النص', 'Text Box'),
  },
  { value: 2, key: 2, name: 'List', label: getLabel('قائمة منسدلة', 'List') },
];
export const elementListType = 2;

export const IntervalRefillList = [
  {
    value: 1,
    key: 1,
    nameEn: 'Day',
    nameAr: 'يومي',
    label: getLabel('يومي', 'Day'),
  },
  { value: 2, key: 2, nameEn: 'Week', nameAr: 'اسبوعي', label: 'Week' },
  { value: 3, key: 3, nameEn: 'Month', nameAr: 'شهري', label: 'Month' },
  { value: 4, key: 4, nameEn: 'Year', nameAr: 'السنة', label: 'Year' },
];

export const offDayYesNoList = [
  {
    id: -1,
    value: -1,
    name: '--- Please Select ---',
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
  },
  {
    id: 1,
    value: true,
    name: 'Yes',
    label: getLabel(
      'نعم',
      'Yes'
    ),
  },
  {
    id: 2,
    value: false,
    name: 'No',
    label: getLabel(
      'لا',
       'No'
    ),
  },
];
export const yesNoList = [
  {
    id: 1,
    value: true,
    name: 'Yes',
    label: getLabel(
      'نعم',
      'Yes'
    ),
  },
  {
    id: 2,
    value: false,
    name: 'No',
    label: getLabel(
      'لا',
       'No'
    ),
  },
];

export const addonStatusList = [
  {
    code: 'enableMainRule',
    status: 3,
  },
  {
    code: 'enableTolerance',
    status: 3,
  },
  {
    code: 'enableForcedStartEndTiming',
    status: 3,
  },
  {
    code: 'enableCompensationCoreHours',
    status: 3,
  },
  {
    code: 'enablePersonalHours',
    status: 3,
  },
  {
    code: 'enablePrayerBreak',
    status: 3,
  },
  {
    code: 'enableOvertime',
    status: 3,
  },
  {
    code: 'enableMobilePreCheckIn',
    status: 3,
  },
  {
    code: 'enableLunchBreak',
    status: 3,
  },
  {
    code: 'enableRemoteWork',
    status: 3,
  },
  {
    code: 'enableBadWeather',
    status: 3,
  },
  {
    code: 'enableWorkPermission',
    status: 3,
  },
];
export const addOnList = [
  {
    code: 'enableTolerance',
    startTimeTolerance: 0,
    endTimeTolerance: 0,
    betweenStartEndTimeTolerance: 0,
    maxAllowedNumberOfOutInPerDay: 0,
  },
  {
    code: 'enableForcedStartEndTiming',
    absentIfStartAfter: 0,
    absentIfStartBefore: 0,
  },
  {
    code: 'enableCompensationCoreHours',
    maxHourToCompensations: 0,
  },
  {
    code: 'enablePersonalHours',
    allowedPersonalHours: 0,
    refillPersonalHoursEveryDayWeekMonthYear: 0,
    workFlowIDPersonalHours: '',
  },

  {
    code: 'enablePrayerBreak',
    prayerFromTime: 0,
    prayerToTime: 0,
    prayerDuration: 0,
  },
  {
    code: 'enableOvertime',
    overTimeFromTime: 0,
    overTimeToTime: 0,
  },
  {
    code: 'enableMobilePreCheckIn',
    mobilePreCheckInMinutes: 0,
    mobilePreCheckStartTime: 0,
    mobilePreCheckEndTime: 0,
  },
  {
    code: 'enableLunchBreak',
    lunchBreakFromTime: 0,
    lunchBreakToTime: 0,
    lunchBreakDuration: 0,
  },
  {
    code: 'enableRemoteWork',
    workFlowIDManualEntry: '',
  },
  {
    code: 'enableBadWeather',
    workFlowIDBadWeather: '',
  },
  {
    code: 'enableWorkPermission',
    workFlowIDWorkPermission: '',
  },
];

export const WorkFlowEsclatedActionList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  {
    id: 1,
    value: 1,
    label: 'Auto Approve',
    nameAr: 'Auto Approve',
    nameEn: 'Auto Approve',
  },
  {
    id: 2,
    value: 2,
    label: 'Auto Reject',
    nameAr: 'Auto Reject',
    nameEn: 'Auto Reject',
  },
];

export const targetEmployeeTypeList = [
  {
    id: 1,
    value: 1,
    label: getLabel('الشركة', 'Company'),
    nameAr: 'الشركة',
    nameEn: 'Company',
    targetIDField: 'CompanyID',
  },
  {
    id: 2,
    value: 2,
    label: getLabel('موظف', 'Employee'),
    nameAr: 'موظف',
    nameEn: 'Employee',
    targetIDField: 'EmployeeID',
  },
  {
    id: 3,
    value: 3,
    label: getLabel('الكيان / القسم', 'Entity / Department'),
    nameAr: 'الكيان / القسم',
    nameEn: 'Entity / Department',
    targetIDField: 'EntityID',
  },
  {
    id: 4,
    value: 4,
    label: getLabel('الموقع', 'Location'),
    nameAr: 'الموقع',
    nameEn: 'Location',
    targetIDField: 'LocationID',
  },
  {
    id: 5,
    value: 5,
    label: getLabel('المنطقة', 'Area'),
    nameAr: 'المنطقة',
    nameEn: 'Area',
    targetIDField: 'AreaID',
  },
  {
    id: 6,
    value: 6,
    label: getLabel('المجموعة', 'Group'),
    nameAr: 'المجموعة',
    nameEn: 'Group',
    targetIDField: 'GroupID',
  },
  {
    id: 7,
    value: 7,
    label: getLabel('الفئة / المسمى الوظيفي', 'Category / Designation'),
    nameAr: 'الفئة / المسمى الوظيفي',
    nameEn: 'Category / Designation',
    targetIDField: 'CategoryID',
  },
];

export const workFlowEsclatedAfter = [
  {
    id: 1,
    value: 1,
    label: 'Auto Reject',
    nameAr: 'Auto Reject',
    nameEn: 'Auto Reject',
  },
  {
    id: 2,
    value: 2,
    label: 'Auto Approve',
    nameAr: 'Auto Approve',
    nameEn: 'Auto Approve',
  },
];

export const employeeGroupTypeList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    name: '--- Please Select ---',
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  { id: 1, value: 1, label: 'Policy', nameAr: 'Policy', nameEn: 'Policy' },
  {
    id: 2,
    value: 2,
    label: 'Work Flow',
    nameAr: 'Work Flow',
    nameEn: 'Policy',
  },
];

export const limitLeaveBuilderList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  {
    id: 1,
    value: 1,
    label: 'OnePerMonth',
    nameAr: 'OnePerMonth',
    nameEn: 'OnePerMonth',
  },
  {
    id: 2,
    value: 2,
    label: 'TwoPerMonth',
    nameAr: 'TwoPerMonth',
    nameEn: 'TwoPerMonth',
  },
  {
    id: 3,
    value: 3,
    label: 'OnePerWeek',
    nameAr: 'OnePerWeek',
    nameEn: 'OnePerWeek',
  },
  {
    id: 4,
    value: 4,
    label: 'TwoPerWeek',
    nameAr: 'TwoPerWeek',
    nameEn: 'TwoPerWeek',
  },
];
export const policyAddOnStatusList = [
  {
    id: 3,
    value: 3,
    label: 'Skip',
    name: 'Skip',
    nameAr: 'Skip',
    nameEn: 'Skip',
  },
  {
    id: 1,
    value: 1,
    label: 'Enable',
    name: 'Enable',
    nameAr: 'Enable',
    nameEn: 'Enable',
  },
  {
    id: 2,
    value: 2,
    label: 'Disable',
    name: 'Disable',
    nameAr: 'Disable',
    nameEn: 'Disable',
  },
];
export const auditLogList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    name: '--- Please Select ---',
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  {
    id: 2,
    value: 2,
    label: 'Deleted',
    name: 'Deleted',
    nameAr: 'Deleted',
    nameEn: 'Deleted',
  },
  {
    id: 3,
    value: 3,
    label: 'Modified',
    name: 'Modified',
    nameAr: 'Modified',
    nameEn: 'Modified',
  },
  {
    id: 4,
    value: 4,
    label: 'Added',
    name: 'Added',
    nameAr: 'Added',
    nameEn: 'Added',
  },
];
export const notificationScheduleTypeList = [
  {
    id: -1,
    value: -1,
    label: getLabel('يرجى الاختيار', '--- Please Select ---'),
  },
  {
    id: 1,
    value: 1,
    label: getLabel('يومي', 'Daily'),
    controlType: 'Daily',
  },
  {
    id: 2,
    value: 2,
    label: getLabel('اسبوعي', 'Weekly'),
    controlType: 'WeekDay',
  },
  {
    id: 3,
    value: 3,
    label: getLabel('شهري', 'Monthly'),
    controlType: 'Monthly',
  },
];

export const notificationTypeList = [
  {
    id: -1,
    value: -1,
    label: getLabel('يرجى الاختيار', '--- Please Select ---'),
  },
  {
    id: 1,
    value: 'delay',
    label: getLabel('تأخير', 'Delay'),
    controlType: 'Delay',
  },
  {
    id: 2,
    value: 'absent',
    label: getLabel('غياب', 'Absent'),
    controlType: 'Absent',
  },
  {
    id: 3,
    value: 'earlyout',
    label: getLabel('الخروج المبكر', 'Early Out'),
    controlType: 'EarlyOut',
  },
  {
    id: 4,
    value: 'violation',
    label: getLabel('مخالفة', 'Violation'),
    controlType: 'Violation',
  },
];

export const toAssignTypeList = [
  {
    id: -1,
    value: -1,
    label: getLabel('يرجى الاختيار', '--- Please Select ---'),
  },
  {
    id: 1,
    value: 'employee',
    label: getLabel('موظف محدد', 'Specific Employee'),
  },
  {
    id: 2,
    value: 'group',
    label: getLabel('مجموعة', 'Group'),
  },
  {
    id: 3,
    value: 'manager',
    label: getLabel('المدير المباشر', 'Direct Manager'),
  },
  {
    id: 4,
    value: 'requester',
    label: getLabel('المُقدم', 'Requester'),
  },
];

export const toCCTypeList = [
  {
    id: -1,
    value: -1,
    label: getLabel('يرجى الاختيار', '--- Please Select ---'),
  },
  {
    id: 1,
    value: 'employee',
    label: getLabel('موظف محدد', 'Specific Employee'),
  },
  {
    id: 2,
    value: 'group',
    label: getLabel('مجموعة', 'Group'),
  },
  {
    id: 3,
    value: 'manager',
    label: getLabel('المدير المباشر', 'Direct Manager'),
  },
  {
    id: 4,
    value: 'requester',
    label: getLabel('المُقدم', 'Requester'),
  },
];

export const notificationKindList = [
  // {
  //   id: 0,
  //   value: 0,
  //   label: getLabel('--- يرجى الاختيار ---', '--- Please Select ---'),
  // },
  {
    id: 1,
    value: 1,
    label: getLabel('البريد الالكتروني', 'Email'),
  },
  {
    id: 2,
    value: 2,
    label: getLabel('رسالة نصية', 'SMS'),
  },
];

export const parametersList = [
  {
    id: 1,
    value: 'date',
    label: getLabel('تاريخ', 'Date'),
    controlType: 'Date',
  },
  {
    id: 2,
    value: 'employeeName',
    label: getLabel('اسم الموظف', 'Employee Name'),
    controlType: 'EmployeeName',
  },
  {
    id: 3,
    value: 'employeeNo',
    label: getLabel('رقم الموظف', 'Employee No'),
    controlType: 'EmployeeNo',
  },
  {
    id: 4,
    value: 'duration',
    label: getLabel('المدة', 'Duration'),
    controlType: 'Duration',
  },
];



export const categoryReportList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    name: '--- Please Select ---',
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  {
    id: 1,
    value: 1,
    label: 'Permission ',
    name: 'Permission ',
    nameAr: 'Permission ',
    nameEn: 'Permission ',

    subCategoryList: [
      {
        id: -1,
        value: -1,
        label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
        name: '--- Please Select ---',
        nameAr: '--- Please Select ---',
        nameEn: '--- Please Select ---',
        headers: [],
      },
      {
        id: 1,
        value: 1,
        label: 'All',
        name: 'All',
        nameAr: 'All',
        nameEn: 'All',
        headers: [
          'Employee',
          'Permission Type',
          'Date',
          'From Time',
          'To Time',
          'Duration',
        ],
      },
      {
        id: 2,
        value: 2,
        label: 'Personal Permission',
        name: 'Personal Permission',
        nameAr: 'Personal Permission',
        nameEn: 'Personal Permission',
        headers: ['Employee', 'Date', 'From Time', 'To Time', 'Duration'],
      },
      {
        id: 3,
        value: 3,
        label: 'Dutty Permission',
        name: 'Dutty Permission',
        nameAr: 'Dutty Permission',
        nameEn: 'Dutty Permission',
        headers: ['Employee', 'Date', 'From Time', 'To Time', 'Duration'],
      },
    ],
  },
  {
    id: 2,
    value: 2,
    label: 'Leave ',
    name: 'Leave ',
    nameAr: 'Leave ',
    nameEn: 'Leave ',
    subCategoryList: [
      {
        id: -1,
        value: -1,
        label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
        name: '--- Please Select ---',
        nameAr: '--- Please Select ---',
        nameEn: '--- Please Select ---',
        headers: [],
      },
      {
        id: 1,
        value: 1,
        label: 'All',
        name: 'All',
        nameAr: 'All',
        nameEn: 'All',
        headers: ['Employee', 'Leave Type', 'From Date', 'To Date', 'Duration'],
      },
      {
        id: 2,
        value: 2,
        label: 'Annual Leave',
        name: 'Annual Leave',
        nameAr: 'Annual Leave',
        nameEn: 'Annual Leave',
        headers: ['Employee', 'From Date', 'To Date', 'Duration'],
      },
      {
        id: 3,
        value: 3,
        label: 'Sick Leave',
        name: 'Sick Leave',
        nameAr: 'Sick Leave',
        nameEn: 'Sick Leave',
        headers: ['Employee', 'From Date', 'To Date', 'Duration'],
      },
      {
        id: 4,
        value: 4,
        label: 'Medical Leave',
        name: 'Medical Leave',
        nameAr: 'Medical Leave',
        nameEn: 'Medical Leave',
        headers: ['Employee', 'From Date', 'To Date', 'Duration'],
      },
    ],
  },
  {
    id: 3,
    value: 3,
    label: 'Attendance ',
    name: 'Attendance ',
    nameAr: 'Attendance ',
    nameEn: 'Attendance ',
    subCategoryList: [
      {
        id: -1,
        value: -1,
        label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
        name: '--- Please Select ---',
        nameAr: '--- Please Select ---',
        nameEn: '--- Please Select ---',
        headers: [],
      },
      {
        id: 1,
        value: 1,
        label: 'Transaction ',
        name: 'Transaction ',
        nameAr: 'Transaction ',
        nameEn: 'Transaction ',
        code: 'Transactions',
        headers: [
          'Employee NameEn',
          'Employee No',
          'Transaction Time',
          'Transaction Type',
          'Reader Name',
        ],
      },
      {
        id: 2,
        value: 2,
        label: 'Duration ',
        name: 'Duration ',
        nameAr: 'Duration ',
        nameEn: 'Duration ',
        code: 'Duration',
        headers: ['Employee NameEn', 'EmployeeNo', 'Date', 'Duration'],
      },
      {
        id: 3,
        value: 3,
        label: 'Inout ',
        name: 'Inout ',
        nameAr: 'Inout ',
        nameEn: 'Inout ',
        code: 'InOut',
        headers: [
          'Employee NameEn',
          'Employee No',
          'Date In',
          'Date Out',
          'Reader In',
          'Reader Out',
        ],
      },
    ],
  },
  {
    id: 4,
    value: 4,
    label: 'Violation ',
    name: 'Violation ',
    nameAr: 'Violation ',
    nameEn: 'Violation ',
    subCategoryList: [
      {
        id: -1,
        value: -1,
        label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
        name: '--- Please Select ---',
        nameAr: '--- Please Select ---',
        nameEn: '--- Please Select ---',
        headers: [],
      },

      {
        id: 1,
        value: 1,
        label: 'Late ',
        name: 'Late ',
        nameAr: 'Late ',
        nameEn: 'Late ',
        headers: ['Employee', 'Date', 'Duration'],
      },
      {
        id: 2,
        value: 2,
        label: 'Earlyout ',
        name: 'Earlyout ',
        nameAr: 'Earlyout ',
        nameEn: 'Earlyout ',
        headers: ['Employee', 'Date', 'Duration'],
      },

      {
        id: 5,
        value: 5,
        label: 'Absent ',
        name: 'Absent ',
        nameAr: 'Absent ',
        nameEn: 'Absent ',
        headers: ['Employee', 'Date'],
      },
    ],
  },
];
export const genderList = [
  {
    id: -1,
    value: -1,
    label: getLabel('---يرجى الاختيار ---', '--- Please Select ---'),
    name: '--- Please Select ---',
    nameAr: '---يرجى الاختيار ---',
    nameEn: '--- Please Select ---',
  },
  {
    id: 1,
    value: 1,
    label: getLabel('ذكر', 'Male'),
    name: 'Male',
    nameAr: 'Male',
    nameEn: 'Male',
  },
  {
    id: 2,
    value: 2,
    label: getLabel('انثى', 'Female'),
    name: 'Female',
    nameAr: 'Female',
    nameEn: 'Female',
  },
];
export const langList = [
  {
    id: -1,
    value: -1,
    label:  getLabel(
      '---- الرجاء الاختيار ----',
      '---- Please Select ----'
    ),
    name: '--- Please Select ---',
  },
  { id: 1, value: 1, label: getLabel('عربي', 'Arabic'), name: 'Arabic' },
  { id: 2, value: 2, label: getLabel('انجليزي', 'English'), name: 'English' },
];
export const transactionTypeList = [
  {
    key: '',
    value: '',
    label: 'manualEntry.pleaseSelect',
    name: '--- Please Select ---',
  },
  { key: 1, value: 1, label: 'manualEntry.in', name: 'In' },
  { key: 2, value: 2, label: 'manualEntry.out', name: 'Out' },
];
export const virtualDirectoryName = '/';
// export const virtualDirectoryName = '';
export const adminRoot = `/`;
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;

export const apiPath = await getApiPath();
export const apiPathLogin = await getLoginApiPath();

export const isAzureAuth = 1;
export const itemPerPage = 10;
export const presentStatus = 6;
export const holidayStatus = 10;
export const absentCode = 1;
export const absentByPolicyCode = 2;
export const earlyOutCode = 3;
export const delayCode = 4;
export const stepOutCode = 5;
export const durationCode = 6;
export const leaveCode = 7;
export const generalMonthlyFormat = 'YYYY-MM';
export const generalFormatDate = 'YYYY-MM-DD';
export const generalFormatDateForTableDate = 'DD/MM/YYYY';
export const generalFullFormatDate = 'DD-MM-YYYYTHH:mm';
export const generalFullFormatDateTable = 'DD/MM/YYYY HH:mm';
export const generalFullFormatTime = 'HH:mm';
export const generalFullFormatDateForDatePicker = 'yyyy/MM/dd h:mm aa';
export const generalFormatDateForDatePicker = 'dd/MM/yyyy';

export const MONTH_KEYS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
export const SHORT_WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
export const FULL_WEEKDAY_KEYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const getLocalizedMonthLabel = (dateValue, translate, fallbackFormat = 'MMM') => {
  const parsed = moment(dateValue);
  if (!parsed.isValid()) return '';
  const key = MONTH_KEYS[parsed.month()];
  return typeof translate === 'function' ? translate(`common.${key}`) || parsed.format(fallbackFormat) : parsed.format(fallbackFormat);
};

export const getLocalizedShortWeekdayLabel = (dateValue, translate, fallbackFormat = 'ddd') => {
  const parsed = moment(dateValue);
  if (!parsed.isValid()) return '';
  const key = SHORT_WEEKDAY_KEYS[parsed.day()];
  return typeof translate === 'function' ? translate(`common.weekdays.${key}`) || parsed.format(fallbackFormat) : parsed.format(fallbackFormat);
};

export const getLocalizedFullWeekdayLabel = (dateValue, translate, fallbackFormat = 'dddd') => {
  const parsed = moment(dateValue);
  if (!parsed.isValid()) return '';
  const key = FULL_WEEKDAY_KEYS[parsed.day()];
  return typeof translate === 'function' ? translate(`common.${key}`) || parsed.format(fallbackFormat) : parsed.format(fallbackFormat);
};

export const formatLocalizedDateLabel = (dateValue, translate, dayFormat = 'D', monthFallbackFormat = 'MMM', yearFormat = 'YYYY') => {
  const parsed = moment(dateValue);
  if (!parsed.isValid()) return '';
  return `${parsed.format(dayFormat)} ${getLocalizedMonthLabel(parsed, translate, monthFallbackFormat)} ${parsed.format(yearFormat)}`;
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.redruby';

export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const requesterWorkFlowID = 7;

export const firstItem = {
  id: -1,
  key: -1,
  descriptionEn: getLabel(
    '---- الرجاء الاختيار ----',
    '---- Please Select ----'
  ),
  descriptionAr: '---- الرجاء الاختيار ----',
  description: getLabel('---- الرجاء الاختيار ----', '---- Please Select ----'),
};
export const firstListItem = {
  id: '',
  value: '',
  label: getLabel('---- الرجاء الاختيار ----', '---- Please Select ----'),
};
export const firstItemLabel = {
  id: -1,
  key: -1,
  label: getLabel('---- الرجاء الاختيار ----', '---- Please Select ----')
};

export const currentUser = {
  role: 0,
  fullName: '',
  token: '',
  refreshToken: '',
  image: '',
  listActions: [],
  password: '',
  id: 0,
  email: '',
};

export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const attendanceStatusColors = {
  delay: '#ef4444', // align with timeline color tokens
  violation: '#f63',
  noviolation: '#3b82f6',
  present: '#3b82f6',
  stepout: '#facc15',
  permission: '#06b6d4',
  remote: '#e860ff',
  leave: '#a855f7',
  earlyout: '#f43f5e',
  overtime: '#fb923c',
  absent: '#bf3c00',
  holiday: '#4CAF50',
  Restday: '#9ca3af',
  exception: '#93c5fd',
  'لا مخالفة': '#3b82f6', // no violation
  'خروج مبكر': '#f43f5e', // early out
  'يوم راحة': '#9ca3af', // rest day
};

export const getAttendanceStatusColor = (status) => {
  if (!status) return '#9ca3af';

  const normalized = String(status).toLowerCase().replace(/[\s_-]+/g, '');

  if (normalized.includes('remote')) {
    return attendanceStatusColors.remote || '#9ca3af';
  }

  // Handle backend/UI variants like "Present(...)" or "EmployeePresent" by matching substrings.
  // Keep this limited to high-signal keywords to avoid false positives.
  if (normalized.includes('present') || normalized.includes('active')) {
    return attendanceStatusColors.noviolation || '#9ca3af';
  }
  if (normalized.includes('work')) {
    return attendanceStatusColors.present || '#9ca3af';
  }

  const aliasMap = {
    // Rationalize dashboard statuses to the canonical palette keys
    // late ~= delay
    late: 'delay',
    latecoming: 'delay',
    lc: 'delay',
    lc1: 'delay',
    lc2: 'delay',
    lc3: 'delay',
    restday: 'Restday',
    rest: 'Restday',
    l: 'delay',
    delay: 'delay',
    'تاخير': 'delay',
    violation: 'violation',
    v: 'violation',
    'مخالفة': 'violation',
    work: 'present',
    w: 'present',
    working: 'present',
    // present/on-time ~= noviolation
    present: 'noviolation',
    presentnoviolation: 'noviolation',
    noviolationpresent: 'noviolation',
    noviolation: 'noviolation',
    'حظور': 'noviolation',
    'حضور': 'noviolation',
    active: 'noviolation',
    p: 'noviolation',
    on: 'noviolation',
    ontime: 'noviolation',
    intime: 'noviolation',
    in: 'noviolation',
    i: 'noviolation',
    attend: 'noviolation',
    noViolation: 'noviolation',
    remotework: 'remote',
    remote: 'remote',
    r: 'remote',
    leave: 'leave',
    stepout: 'stepout',
    s: 'stepout',
    stepoutpermission: 'stepout',
    earlyout: 'earlyout',
    earlyoutt: 'earlyout',
    earlyleave: 'earlyout',
    'خروجمبكر': 'earlyout',
    e: 'earlyout',
    overtime: 'overtime',
    ot: 'overtime',
    o: 'overtime',
    absent: 'absent',
    absentbefore: 'absent',
    absentafter: 'absent',
    a: 'absent',
    'غياب': 'absent',
    permission: 'permission',
    holiday: 'holiday',
    holidays: 'holiday',
    h: 'holiday',
    'عطلةرسمية': 'holiday',
    publicholiday: 'holiday',
    publicholidays: 'holiday',
    ph: 'holiday',
    'يومراحة': 'Restday',
    exception: 'exception',
    excep: 'exception',
  };
  const canonical = aliasMap[normalized] || normalized;
  return attendanceStatusColors[canonical] || '#9ca3af';
};

export const hrAttendanceStatusColors = {
  delay: { bg: '#fee2e2', text: '#ef4444' },
  earlyout: { bg: '#ffc7d1', text: '#f43f5e' },
  violation: { bg: '#ffdbce', text: '#ff6633' },
  leave: { bg: '#eddffc', text: '#a855f7' },
  present: { bg: '#dce9ff', text: '#3b82f6' },
  noviolation: { bg: '#dce9ff', text: '#3b82f6' },
  remote: { bg: '#fbe3ff', text: '#c718e4' },
  absent: { bg: '#ffcfba', text: '#bf3c00' },
  absentbefore: { bg: '#f8cabd', text: '#ab2800' },
  absentafter: { bg: '#ffe7dc', text: '#d35014' },
  exception: { bg: '#b7d9ff', text: '#1161ba' },
  holiday: { bg: '#daffdb', text: '#4caf50' },
  Restday: { bg: '#e1e1e1', text: '#7a7e86' },
};

export const getHrAttendanceStatusColor = (status) => {
  if (!status) return { bg: '#e1e1e1', text: '#7a7e86' };

  let normalized = String(status).toLowerCase().replace(/[\s_-]+/g, '');

  if (normalized.includes('remote')) {
    normalized = 'remote';
  } else if (
    normalized.includes('noviolation') ||
    normalized.includes('present') ||
    normalized === 'active' ||
    normalized === 'p' ||
    normalized === 'on' ||
    normalized === 'ontime' ||
    normalized === 'intime' ||
    normalized === 'in' ||
    normalized === 'attend' ||
    normalized === 'work' ||
    normalized === 'working' ||
    normalized === 'w'
  ) {
    normalized = 'present';
  } else if (normalized.includes('earlyout') || normalized === 'earlyleave' || normalized === 'e') {
    normalized = 'earlyout';
  } else if (normalized.includes('delay') || normalized.includes('late') || normalized === 'l' || normalized.startsWith('lc')) {
    normalized = 'delay';
  } else if (normalized.includes('violation') || normalized === 'v') {
    normalized = 'violation';
  } else if (normalized === 'absentbefore') {
    normalized = 'absentbefore';
  } else if (normalized === 'absentafter') {
    normalized = 'absentafter';
  } else if (normalized.includes('absent') || normalized === 'a') {
    normalized = 'absent';
  } else if (normalized.includes('leave')) {
    normalized = 'leave';
  } else if (normalized.includes('exception')) {
    normalized = 'exception';
  } else if (normalized.includes('holiday') || normalized === 'h') {
    normalized = 'holiday';
  } else if (normalized.includes('rest')) {
    normalized = 'Restday';
  }

  const colors = hrAttendanceStatusColors[normalized];
  if (colors) return colors;

  const fallback = getAttendanceStatusColor(status);
  return { bg: fallback, text: fallback };
};

export const flagsData = [
  {
    nameAr: 'وضع حرج',
    nameEn: 'Crtical Customer',
    id: 1,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'وضع عادي',
    nameEn: 'Normal Customer',
    id: 2,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'وضع حرج جدا',
    nameEn: 'Very crtical Customer',
    id: 3,
    date: moment().format('YYYY-MM-DD'),
  },
];

export const visitKindData = [
  {
    nameAr: 'زيارة افتراضية',
    nameEn: 'Virtual Visit',
    id: 1,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'زيارة واقعية',
    nameEn: 'Actual Visit',
    id: 2,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'اتصال هاتفي',
    nameEn: 'Phone Call',
    id: 3,
    date: moment().format('YYYY-MM-DD'),
  },
];
export const visitTypeData = [
  {
    nameAr: 'زيارة بالمشفى',
    nameEn: 'Hospital Visit',
    id: 1,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'زيارة بالمنزل',
    nameEn: 'Home Visit',
    id: 2,
    date: moment().format('YYYY-MM-DD'),
  },
  {
    nameAr: 'زيارة بالمنشأة',
    nameEn: 'Job Visit',
    id: 3,
    date: moment().format('YYYY-MM-DD'),
  },
];
export const visitQuestionData = [
  {
    nameAr: 'الدخل الشهري',
    nameEn: 'Monthly Income',
    id: 1,
    date: moment().format('YYYY-MM-DD'),
    type: 1,
    answerList: [
      {
        id: 1,
        nameAr: 'اقل من 50,000',
        nameEn: 'less than 50,000',
        key: 4,
        label: 'less than 50,000',
      },
      {
        id: 2,
        nameAr: 'اقل من 100,000',
        nameEn: 'less than 100,000',
        key: 4,
        label: 'less than 100,000',
      },
      {
        id: 3,
        nameAr: 'اكثر من 100,000',
        nameEn: 'more than 100,000',
        key: 4,
        label: 'more than 100,000',
      },
      { id: 4, nameAr: 'اخرى', nameEn: 'Other', key: 4, label: 'Other' },
    ],
  },

  {
    nameAr: '؟هل تمت زيارتك مسبقا',
    nameEn: 'Have we visited you before?',
    id: 2,
    date: moment().format('YYYY-MM-DD'),
    type: 2,
    answerList: [
      {
        id: 1,
        nameAr: '--- يرجى الاختيار---',
        nameEn: '--- Please Select ----',
        key: 1,
        label: '--- Please Select ----',
      },
      { id: 2, nameAr: 'نعم', nameEn: 'Yes', key: 2, label: 'Yes' },
      { id: 3, nameAr: 'لا', nameEn: 'NO', key: 3, label: 'No' },
    ],
  },
  {
    nameAr: 'هل الراتب يغطي الاحتياجات الخاصة؟',
    nameEn: 'does the salary enough for you?',
    id: 3,
    date: moment().format('YYYY-MM-DD'),
    type: 3,
    answerList: [
      { id: 1, nameAr: 'نعم', nameEn: 'Yes', key: 1, label: 'Yes' },
      { id: 2, nameAr: 'لا', nameEn: 'NO', key: 2, label: 'No' },
    ],
  },
  {
    nameAr: 'الممتلكات الخاصة بك؟',
    nameEn: 'Your property?',
    id: 4,
    date: moment().format('YYYY-MM-DD'),
    type: 4,
  },
];

export const PolicyFormCode = {
  TAPolicy: 'TA Policy',
  // TAPolicyOverTime: "TA Policy OverTime",
};

export const ScheduleType = {
  Normal: 1,
  Flexible: 2,
  Open: 3,
};

export const GraceType = {
  Male: 1,
  Female: 2,
  AllEmployees: 3,
};

export const WeekDays = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};
export const dayColors = [
  ['#FF5733', '#f98870'], // Monday
  ['#008918', '#81975b'], // Tuesday
  ['#3357FF', '#4f9ed3'], // Wednesday
  ['#FFC300', '#ffd858'], // Thursday
  ['#8E44AD', '#b16dcf'], // Friday
  ['#16A085', '#1ABC9C'], // Saturday
  ['#E74C3C', '#F1948A'], // Sunday
];
export const questionTypeData = [
  { id: 1, label: 'Multi Choose' },
  {
    id: 2,
    label: 'DrowpDown',
  },
  {
    id: 3,
    label: 'One Choose',
  },
  {
    id: 4,
    label: 'Add Text',
  },
];
export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const emirateData = [
  { id: 1, label: 'Abu Dhabi' },
  { id: 2, label: 'Dubai' },
  { id: 3, label: 'Sharjah' },
  {
    id: 4,
    label: 'Ajman',
  },
  {
    id: 5,
    label: 'Umm Al-Quwain',
  },
  {
    id: 6,
    label: 'Fujairah',
  },
  {
    id: 7,
    label: 'Ras Al Khaimah',
  },
];

export const userGroup = [
  { id: 1, label: 'Admin' },
  { id: 2, lable: 'Create Visit' },
  { id: 3, label: 'Create Questions' },
  { id: 4, label: 'Reporting' },
];

export const visitStatusData = [
  { id: 1, label: 'New' },
  { id: 2, label: 'Start Editing' },
  { id: 3, label: 'Change Data' },
  { id: 4, label: 'Canceled' },
  { id: 5, label: 'Deleted' },
  { id: 6, label: 'Closed' },
];

export const emailData = [
  {
    id: 1,
    nameAr: 'تعريف الزيارة',
    nameEn: 'Create Visit',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 2,
    nameAr: 'بداية الزيارة',
    nameEn: 'Start Visit',
    date: moment().format('YYYY-MM-DD'),
  },
];

export const yearlyBudgetData = [
  {
    id: 1,
    year: 2022,
    date: moment().format('YYYY-MM-DD'),
    budget: 5000000,
    projects: [
      { id: 1, budget: 20000, date: moment().format('YYYY-MM-DD') },
      { id: 2, budget: 40000, date: moment().format('YYYY-MM-DD') },
      { id: 3, budget: 50000, date: moment().format('YYYY-MM-DD') },
    ],
  },
  {
    id: 2,
    year: 2021,
    date: moment().format('YYYY-MM-DD'),
    budget: 4000000,
    projects: [
      { id: 1, budget: 20000, date: moment().format('YYYY-MM-DD') },
      { id: 2, budget: 40000, date: moment().format('YYYY-MM-DD') },
      { id: 3, budget: 50000, date: moment().format('YYYY-MM-DD') },
    ],
  },
  {
    id: 3,
    year: 2020,
    date: moment().format('YYYY-MM-DD'),
    budget: 3000000,
    projects: [
      { id: 1, budget: 20000, date: moment().format('YYYY-MM-DD') },
      { id: 2, budget: 40000, date: moment().format('YYYY-MM-DD') },
      { id: 3, budget: 50000, date: moment().format('YYYY-MM-DD') },
    ],
  },
  {
    id: 4,
    year: 2019,
    date: moment().format('YYYY-MM-DD'),
    budget: 2500000,
    projects: [
      { id: 1, budget: 20000, date: moment().format('YYYY-MM-DD') },
      { id: 2, budget: 40000, date: moment().format('YYYY-MM-DD') },
      { id: 3, budget: 50000, date: moment().format('YYYY-MM-DD') },
    ],
  },
];
export const MartialList = [
  {
    id: -1,
    value: -1,
    label: getLabel('--- يرجى الاختيار ---', '--- Please Select ---'),
    name: '--- Please Select ---',
    nameAr: '--- Please Select ---',
    nameEn: '--- Please Select ---',
  },
  { id: 1, value: 1, label: getLabel('متزوج', 'Married'), name: 'Married' },
  {
    id: 2,
    value: 2,
    label: getLabel('اعزب', 'Un-married'),
    name: 'Un-married',
  },
];
export const projectsData = [
  {
    id: 1,
    nameAr: 'First Project',
    nameEn: 'First Project',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 2,
    nameAr: 'Second Project',
    nameEn: 'Second Project',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 3,
    nameAr: 'THird Project',
    nameEn: 'Third Project',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 4,
    nameAr: 'Fourth Project',
    nameEn: 'Fourth Project',
    date: moment().format('YYYY-MM-DD'),
  },
];

export const generalMeetingDetails = [
  {
    id: 1,
    nameAr: 'First Meeting',
    nameEn: 'First Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 2,
    nameAr: 'Second Meeting',
    nameEn: 'Second Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 3,
    nameAr: 'THird Meeting',
    nameEn: 'Third Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 4,
    nameAr: 'Fourth Meeting',
    nameEn: 'Fourth Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
];
export const notificationData = [
  {
    id: 1,
    titleAr: 'Notification title 1  ',
    titleEn: 'Notification title 1',
    bodyAr: 'body ar Meeting',
    bodyEn: 'body en Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
  {
    id: 2,
    titleAr: 'Notification title 2 ',
    titleEn: 'Notification title 2 ',
    bodyAr: 'body ar Meeting',
    bodyEn: 'body en Meeting',
    date: moment().format('YYYY-MM-DD'),
  },
];
export const AssignTypes = {
  Requestor: 7,
  Manager: 6,
};
export const TimePeriodType = {
  Ramadan: 1,
  Holiday: 2,
};
export const targetEmployeeType = {
  Company: 1,        // Apply to entire company - TargetEmployeeID: CompanyID
  Employee: 2,       // Apply to specific employee - TargetEmployeeID: EmployeeID
  Entity: 3,         // Apply to entity/department - TargetEmployeeID: EntityID
  Location: 4,       // Apply to location - TargetEmployeeID: LocationID
  Area: 5,           // Apply to area - TargetEmployeeID: AreaID
  Group: 6,          // Apply to employee group - TargetEmployeeID: GroupID
  Category: 7, 
  Designation :9,
};
export const violationTypes = {
  Rest: 'R',
  Absent: 'A',
  Leave: 'L',
  Holiday: 'H',
  AbsentByPolicy: 'AP',
  Violation: 'V',
  OffDay: 'Rest',
  RemoteWork: 'RE',
  ConsiderAsAbsentAfter: 'AA',
  ConsiderAsAbsentBefore: 'AB',
  MissingIn: 'MI',
  MissingOut: 'MO',
  Exception: 'E',
  MissingCard: 'MC',
};
export const DailyEventTypes = {
  Absent: 1,
  AbsentByPolicy: 2,
  EarlyOut: 3,
  Delay: 4,
  StepOut: 5,
  Duration: 6,
  Leave: 7,
  None: 8,
  RestDay: 9,
  Hoilday: 10,
  Present: 11,
};
export const NotificationTypes = {
  Default: 0,
};
export const DashboardCardsType = {
  PendingApproval: 4,
  Violations: 3,
  Absent: 1,
  Leaves: 2,
  PermissionRequests: 5,
};

export const DelayEarlyOutTypeReportList = [
  { value: 0, id: 0, label: getLabel('الكل ', 'All'), direction: 'All' },
  {
    value: 1,
    id: 1,
    label: getLabel('الخروج المبكر ', 'Early Out'),
    direction: 'earlyOut',
  },
  {
    value: 2,
    id: 2,
    label: getLabel('التاخير', 'Delay'),
    direction: 'delay',
  },
];
export const StageOrderList = [
  {
    value: 1,
    id: 1,
    label: 1,
  },
  {
    value: 2,
    id: 2,
    label: 2,
  },
  {
    value: 3,
    id: 3,
    label: 3,
  },
  {
    value: 4,
    id: 4,
    label: 4,
  },
  {
    value: 5,
    id: 5,
    label: 5,
  },
  {
    value: 6,
    id: 6,
    label: 6,
  },
  {
    value: 7,
    id: 7,
    label: 7,
  },
  {
    value: 8,
    id: 8,
    label: 8,
  },
  {
    value: 9,
    id: 9,
    label: 9,
  },
  {
    value: 10,
    id: 10,
    label: 10,
  },
];

export const WorkFlowForList = [
  {
    value: 0,
    id: 0,
    label: getLabel('الكل ', 'All Requests'),
  },
  {
    value: 1,
    id: 1,
    label: getLabel('إذن ', 'Permission Request'),
  },
  {
    value: 2,
    id: 2,
    label: getLabel('إجازة ', 'Leave Request'),
  },
  {
    value: 3,
    id: 3,
    label: getLabel('طلب عمل عن بعد ', 'Remote Work Request'),
  },
  {
    value: 4,
    id: 4,
    label: getLabel('إدخال يدوي', 'Manual Entry Request'),
  },
];

export const AbsenteesTypeReportList = [
  { value: 0, id: 0, label: getLabel('الكل ', 'All'), direction: 'All' },
  {
    value: 1,
    id: 1,
    label: getLabel('الغياب ', 'Absent'),
    direction: 'Absent',
  },
  {
    value: 2,
    id: 2,
    label: getLabel('لم يوقع دخول', 'Missing In'),
    direction: 'Missing In',
  },
  {
    value: 3,
    id: 3,
    label: getLabel('لم يوقع خروج', 'Missing Out'),
    direction: 'Missing Out',
  },
  {
    value: 4,
    id: 4,
    label: getLabel('غياب بعد  ', 'Absent After'),
  },
  {
    value: 5,
    id: 5,
    label: getLabel('لم يوقع خروج|دخول', 'Missing In|Out'),
    direction: 'Missing InOut',
  },
  {
    value: 6,
    id: 6,
    label: getLabel('غياب قبل  ', 'Absent Before'),
  },
];

export const WorkFlowStageStatusList = [
  { value: 0, id: 0, label: getLabel('الكل ', 'All'), direction: 'All' },
  { value: 1, id: 1, label: getLabel('قيد الإجراء', 'Pending'), direction: 'Pending' },
  { value: 3, id: 3, label: getLabel('تمت الموافقة', 'Approved'), direction: 'Approved' },
  { value: 4, id: 4, label: getLabel('تم الرفض', 'Rejected'), direction: 'Rejected' },
];
export const statusRequestsList = [
  { value: 0, id: 0, label: '', code: '' },
  { value: 1, id: 1, label: getLabel('تم الطلب', 'Requested'), code: 'Requested' },
  { value: 2, id: 2, label: getLabel('قيد الإجراء', 'Pending'), code: 'Pending' },
  { value: 3, id: 3, label: getLabel('تمت الموافقة', 'Approved'), code: 'Approved' },
  { value: 4, id: 4, label: getLabel('تم الرفض', 'Rejected'), code: 'Rejected' },
];
export const rptRequestTypeCodeList = [
  {
    value: 'Permission',
    id: 'Permission',
    label: getLabel('اذونات', 'Permission')
  },
  {
    value: 'Leave',
    id: 'Leave',
    label: getLabel('اجازات', 'Leave') ,
  },
  {
    value: 'RemoteWork',
    id: 'RemoteWork',
    label: getLabel('عمل عن بعد', 'Remote Work')
  },
];

export const exceptionList = [
  {
    value: 1,
    id: 1,
    label: getLabel('استثناء TA', 'TA Exception'),
  },
  {
    value: 2,
    id: 2,
    label: getLabel('استثناء من الاشعارات', 'Notification Exception'),
  },
  {
    value: 3,
    id: 3,
    label: getLabel('استثناء من المخالفات', 'Violation'),
  },
  {
    value: 4,
    id: 4,
    label: getLabel('استثناء من مخالفات البوابة', 'EGateException'),
  },
];

export const ProbationList = [
  {
    value: 0,
    id: 0,
    label: getLabel('يرجى الاختيار', 'Please Select '),
  },
  {
    value: 1,
    id: 1,
    label: getLabel('الفترة التجريبية 3', ' Probation Period 3'),
  },
  {
    value: 2,
    id: 2,
    label: getLabel('انتهاء الفترة التجريبية 3', ' Probation Period 3 Done'),
  },
  {
    value: 3,
    id: 3,
    label: getLabel('الفترة التجريبية 6', ' Probation Period 6'),
  },
  {
    value: 4,
    id: 4,
    label: getLabel('انتهاء الفترة التجريبية 6', ' Probation Period 6 Done'),
  },
];

export const firstYearItemLabel = {
  id: 0,
  value: 0,
  label: getLabel('---- الرجاء الاختيار ----', '---- Please Select ----')

};

export const leaveRequestActionErrorCodes = {
  '-3': 'fromAndToDateNotSameYear',
  '-4': 'updateLeaseApprovalStarted',
  '-5': 'requestAfterTerminationDate',
  '-6': 'overlapWithOldLeaveRequest',
  '-7': 'exceedLimitForRequest',
  '-8': 'notApplyLeaveBeforeJoinDate',
  '-9': 'overlappingWithRemoteWork',
  '-10' : 'leaveWithinContactDate',
  '-11' : 'leaveExceedsMaxNumberDays',
  '-103': 'cannotUpdateWhilePendingApproval',
};

export const remoteWorkRequestActionErrorCodes = {
  '-2': 'fromDateToDateNotInSameYear',
  '-6': 'overlappingRemoteWorkRequest',
  '-7': 'overlappingLeaveRequest',
  '-8': 'noActiveRemoteWorkSetting',
  '-9': 'yearlyLimitExceeded',
  '-10': 'monthlyLimitExceeded',
  '-11': 'selectValidDateRemoteWorkRange',
  '-103': 'cannotUpdateWhilePendingApproval',
};

export const permissionRequestActionErrorCodes = {
  // Success / initial
  '1': 'SUCCESS',
  '0': 'initialState',

  // General validation & date/time rules
  '-11': 'invalidDateOrShiftPatternOrDuration',
  '-12': 'minMaxDurationNotDefined',
  '-13': 'requestedDurationAboveMaximum',
  '-14': 'requestedDurationBelowMinimum',
  '-15': 'monthlyLimitExceeded',
  '-16': 'dailyLimitExceeded',
  '-18': 'notAllowedBeforeJoinDate',
  '-19': 'notAllowedAfterTerminationDate',
  '-20': 'allowedBeforeDaysExceeded',
  '-21': 'allowedAfterDaysExceeded',
  '-22': 'overlapWithAnotherPermission',
  '-101': 'invalidDateRangeNull',
  '-102': 'toDateEarlierThanFromDate',

  // Workflow/configuration specific
  '-17': 'pendingActionTypeRecalNotFound',
  '-44': 'workflowConfigurationMissing',
  '-99': 'configurationNotFoundInactive',
  '-103': 'cannotUpdateWhilePendingApproval',
  '-104': 'fullDayNoValidScheduleOrRange',
  '-105': 'invalidTimeRangeNullOrOrder',
  '-106': 'configurationNotFoundInactive',
  '-107': 'workflowDefinitionMissing',
  '-108': 'workflowSubmitActionNotFound',
  '-109': 'requiredStatusNotFound',
  '-110': 'requestNotFoundOrDeleted',
  '-111': 'updateNoActiveRecord',
  '-112': 'genericWorkflowFailure',

  // System
  '-1': 'unexpectedSystemError',
};

export const commonActionErrorCodes = {
  // Mobile app device management
  '-120': 'mobile.error.deviceNotFound',
  '-121': 'mobile.error.deviceRegisteredToAnotherEmployee',
  '-122': 'mobile.error.maxDevicesReached',
  '-123': 'mobile.error.deviceAlreadyActive',
  '-124': 'mobile.error.deviceAlreadyInactive',
  '-125': 'mobile.error.deviceDeactivated',
  '-126': 'mobile.error.appVersionNotSupported',
  '-127': 'mobile.error.mobileConfigurationNotFound',
  '-128': 'mobile.error.saveFailed',
  '-129': 'mobile.error.noDevicesToUpdate',
};

export const QuarterList = [
  {
    value: null,
    id: 0,
    label: getLabel('يرجى الاختيار', 'Please Select '),
  },
  {
    value: 1,
    id: 1,
    label: getLabel('الربع 1', 'Quarter 1'),
  },
  {
    value: 2,
    id: 2,
    label: getLabel('الربع 2', 'Quarter 2'),
  },
  {
    value: 3,
    id: 3,
    label: getLabel('الربع 3', 'Quarter 3'),
  },
  {
    value: 4,
    id: 4,
    label: getLabel('الربع 4', 'Quarter 4'),
  },
];


export const tableConfig = {
  tableHeight: '68vh',
};

export const WORK_SCHEDULE_TYPES = {
  WITH_TIME: 'withTime',
  WITHOUT_TIME: 'withoutTime',
  FIXED_SCHEDULE: 'fixedSchedule',
};

export const DEFAULT_PAGINATION = {
  hasNextPage: false,
  hasPreviousPage: false,
  pageNumber: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 1,
};

export const DEFAULT_TIMEZONE = [
  { "value": "UTC", "label": "(UTC+00:00) UTC" },
  { "value": "Asia/Dubai", "label": "(UTC+04:00) Abu Dhabi, Dubai" },
  { "value": "Asia/Riyadh", "label": "(UTC+03:00) Riyadh" },
  { "value": "Asia/Qatar", "label": "(UTC+03:00) Doha" },
  { "value": "Asia/Kuwait", "label": "(UTC+03:00) Kuwait" },
  { "value": "Asia/Bahrain", "label": "(UTC+03:00) Bahrain" },
  { "value": "Asia/Muscat", "label": "(UTC+04:00) Muscat" },
  { "value": "Asia/Amman", "label": "(UTC+03:00) Amman" },
  { "value": "Asia/Beirut", "label": "(UTC+03:00) Beirut" },
  { "value": "Asia/Jerusalem", "label": "(UTC+03:00) Jerusalem" },
  { "value": "Asia/Baghdad", "label": "(UTC+03:00) Baghdad" },
  { "value": "Asia/Karachi", "label": "(UTC+05:00) Karachi" },
  { "value": "Asia/Kolkata", "label": "(UTC+05:30) India" },
  { "value": "Asia/Dhaka", "label": "(UTC+06:00) Dhaka" },
  { "value": "Asia/Bangkok", "label": "(UTC+07:00) Bangkok" },
  { "value": "Asia/Singapore", "label": "(UTC+08:00) Singapore" },
  { "value": "Asia/Kuala_Lumpur", "label": "(UTC+08:00) Kuala Lumpur" },
  { "value": "Asia/Hong_Kong", "label": "(UTC+08:00) Hong Kong" },
  { "value": "Asia/Shanghai", "label": "(UTC+08:00) Shanghai" },
  { "value": "Asia/Tokyo", "label": "(UTC+09:00) Tokyo" },
  { "value": "Australia/Sydney", "label": "(UTC+10:00) Sydney" },
  { "value": "Europe/Istanbul", "label": "(UTC+03:00) Istanbul" },
  { "value": "Europe/Athens", "label": "(UTC+03:00) Athens" },
  { "value": "Europe/Berlin", "label": "(UTC+02:00) Berlin" },
  { "value": "Europe/Paris", "label": "(UTC+02:00) Paris" },
  { "value": "Europe/Rome", "label": "(UTC+02:00) Rome" },
  { "value": "Europe/Madrid", "label": "(UTC+02:00) Madrid" },
  { "value": "Europe/London", "label": "(UTC+01:00) London" },
  { "value": "Africa/Cairo", "label": "(UTC+02:00) Cairo" },
  { "value": "Africa/Johannesburg", "label": "(UTC+02:00) Johannesburg" },
  { "value": "America/New_York", "label": "(UTC-04:00) New York" },
  { "value": "America/Chicago", "label": "(UTC-05:00) Chicago" },
  { "value": "America/Denver", "label": "(UTC-06:00) Denver" },
  { "value": "America/Los_Angeles", "label": "(UTC-07:00) Los Angeles" },
  { "value": "America/Toronto", "label": "(UTC-04:00) Toronto" }
];

// Attendance Duration Icon Options (for timetable icon selection)
export const ShiftIconOptions = (translate) => [
  {
    value: 'DEFAULT',
    label: translate ? translate('attendanceDuration.iconDefault') : 'Default',
    icon: defaultTimetableIcon,
  },
  {
    value: 'EVENING',
    label: translate ? translate('attendanceDuration.iconEvening') : 'Evening',
    icon: eveningTimetableIcon,
  },
  {
    value: 'MORNING',
    label: translate ? translate('attendanceDuration.iconMorning') : 'Morning',
    icon: morningTimetableIcon,
  },
  {
    value: 'AFTERNOON',
    label: translate ? translate('attendanceDuration.iconAfternoon') : 'Afternoon',
    icon: afternoonTimetableIcon,
  },
  {
    value: 'MIDNIGHT',
    label: translate ? translate('attendanceDuration.iconMidnight') : 'Midnight',
    icon: midnightTimetableIcon,
  },
];

// Icon code to icon mapping (for ScheduleShiftBar component)
export const iconCodeToIcon = {
  DEFAULT: defaultTimetableIcon,
  EVENING: eveningTimetableIcon,
  MORNING: morningTimetableIcon,
  AFTERNOON: afternoonTimetableIcon,
  MIDNIGHT: midnightTimetableIcon,
};